import { ShippingGateway } from '@/redux/thunks/ShippingGateway';
import { API_URL, getApiUrl } from '@/utils/api';
import ApiBase from '@/services/ApiBase';

export class HttpShippingGateway extends ApiBase implements ShippingGateway {
  static userUrl = getApiUrl(API_URL.USER, '/cart');

  async getShippingList(storeId: string) {
    return await this.api.getPromisedJSON(`${HttpShippingGateway.userUrl}/${storeId}/getShippings`);
  }
}
